import React, { useState } from "react";
import ShareIcon from '@mui/icons-material/Share';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import PinterestIcon from "@mui/icons-material/Pinterest";
import {
    FacebookShareButton,
    PinterestShareButton,
    TwitterShareButton,
} from "react-share";
import LikeButtonId from "../../common/heart/likebuttonOeuvreId";

const SocialMedia = ({ postImage, URLimage, onclick, onclick2, post, likeButton, pageUrl }) => {
    const [hoverDiv, setHoverDiv] = useState(false)
    const [clickDiv, setClickDiv] = useState(false)

    const hovered = () => {
        if (clickDiv === true) {
            setHoverDiv(false)
        } else {
            setHoverDiv(true)

        }
    }
    const hoverleave = () => {
        setHoverDiv(false)
    }

    const socialClick = () => {
        setClickDiv(!clickDiv)
        setHoverDiv(false)
    }

    return (
        <div className="artwork-social">


            <div className="artwork-social__previews">
                <button className="artwork-social__preview focus-ring" onClick={onclick} type="button">
                    <img className="object-cover" src={`${URLimage}/${postImage}`} alt="img-id" />
                </button>
                <button className="artwork-social__preview focus-ring" onClick={onclick2} type="button">
                    <img className="object-cover logo" src="../images/logo/canape.webp" alt="logo-canape" />
                </button>


            </div>
            <div className="artwork-social__actions">
                <div className="artwork-social__action-row" >

                    <LikeButtonId likesCount={likeButton} oeuvreId={post} />
                    <div className="relative">

                        <button className="artwork-social__share focus-ring" onMouseEnter={hovered} onMouseLeave={hoverleave} onClick={socialClick} type="button">
                            <span className={`${hoverDiv ? "visible" : "hidden"} artwork-social__tooltip`}>
                                Partager
                            </span>
                            <span className={`${clickDiv ? "visible" : "hidden"} artwork-social__share-menu`}>


                                <PinterestShareButton url={pageUrl} media={`${URLimage}/${postImage}`} description="Découvrez cette œuvre sur Pinterest !">
                                    <PinterestIcon />
                                </PinterestShareButton>

                                <FacebookShareButton url={pageUrl} quote="Découvrez cette œuvre !">
                                    <FacebookIcon />
                                </FacebookShareButton>

                                {/* Twitter Share */}
                                <TwitterShareButton url={pageUrl} title="Découvrez cette œuvre !" hashtags={["art", "oeuvre"]}>
                                    <XIcon />
                                </TwitterShareButton>
                            </span>
                            <ShareIcon />
                        </button>

                    </div>


                </div>

            </div>


        </div>
    )
}


export default SocialMedia
